import axios from 'axios';
import _ from 'lodash';
import Constants from '../constants';
import { IBenchmark, IQuestionBenchmarks } from '../models';

// TODO: Update routes when NormLibrary is refactored

// WARNING: INorm is ONLY for mapping to IBenchmark UNTIL naming conventions on NormLibrary update
interface INorm {
	normId: number;
	name: string;
	displayText: string;
	code: string;
	description: string;
}

export function getBenchmarksForQuestionQuery(questionId: number) {
	return Constants.BENCHMARK_LIBRARY_API_QUESTIONS_URL + '/' + questionId + '/Norms';
}

export function getBenchmarkCountsForQuestionsQuery(questionIds: number[]) {
	return Constants.BENCHMARK_LIBRARY_API_QUESTIONS_URL + '/NormCounts?questionIds=' + questionIds.join(',');
}

export function getBenchmarksByIdsQuery(benchmarkIds: number[]) {
	const query = Constants.BENCHMARK_LIBRARY_API_BENCHMARKS_URL + '?normIds=' + benchmarkIds.join(',');
	return query;
}

export async function getBenchmarksForQuestions() {
	const res = await axios.get<
		{
			questionId: number;
			normIds: number[];
		}[]
	>(Constants.BENCHMARK_LIBRARY_API_QUESTIONS_URL);
	return res.data.map<IQuestionBenchmarks>((question) => {
		return {
			questionId: question.questionId,
			benchmarkIds: question.normIds,
		};
	});
}

export async function getBenchmarksForQuestion(questionId: number) {
	const res = await axios.get(getBenchmarksForQuestionQuery(questionId));
	if (res.status === 200) {
		// TODO: remove this when naming conventions on Norm side update
		return mapBenchmarkData(res.data);
		// return res.data;
	}
	throw Error('An error occurred trying to fetch benchmarks.');
}

export async function getBenchmarkCountForQuestions(questionIds: number[]) {
	const res = await axios.get(getBenchmarkCountsForQuestionsQuery(questionIds));
	if (res.status === 200) {
		const entries = Object.keys(res.data).map((k) => [Number(k), res.data[k]]) as any;
		return new Map<number, number>(entries);
	}
	throw Error('An error occurred trying to fetch benchmarks.');
}

export async function getBenchmarks() {
	const res = await axios.get(Constants.BENCHMARK_LIBRARY_API_BENCHMARKS_URL);
	if (res.status === 200) {
		// TODO: remove this when naming conventions on Norm side update
		return mapBenchmarkData(res.data);
		// return res.data;
	}
	throw new Error('An error occurred trying to fetch benchmarks.');
}

export async function getClientBenchmarks(clientId: number) {
	// Survey Builder pages these client-side, but the Norm Library API
	// does not return all records by default, so we need to request
	// more than exist for backwards compatibility with current Survey Builder behavior.
	const url = `${Constants.BENCHMARK_LIBRARY_API_CLIENT_BENCHMARKS_URL.replace(
		'{clientId}',
		clientId.toString(),
	)}?offset=0&limit=all&ensureFallbackList=true`;

	try {
		const response = await axios.get<INorm[]>(url);
		return mapBenchmarkData(response.data);
	} catch {
		throw new Error('An error occurred trying to fetch benchmarks.');
	}
}

export async function getBenchmarksByIds(benchmarkIds: number[]) {
	const res = await axios.get(getBenchmarksByIdsQuery(benchmarkIds));
	if (res.status === 200) {
		return mapBenchmarkData(res.data);
	}
	throw new Error('An error occurred trying to fetch benchmarks.');
}

export async function getGlobalTopQuartileId() {
	const res = await axios.get<number>(Constants.BENCHMARKS_API_GLOBALTOPQUARTILE);
	return res.data;
}

function mapBenchmarkData(norms: INorm[]) {
	return _.map<INorm, IBenchmark>(norms, (norm: INorm) => ({
		benchmarkId: norm.normId,
		name: norm.name,
		displayText: norm.displayText,
		code: norm.code,
		description: norm.description,
	}));
}
